import Button from "devextreme-react/button";
import { useContext, useState } from "react";
import { MaterialOrderContext } from "../context/MaterialOrderContext";
import { apiGenerateMaterialOrderReport } from "../api/get-material-order-report";
import { Buffer } from 'buffer';
import { showErrorMessage } from "../../../../utils/messages";
import { MaterialOrderReportType } from "../types/MaterialOrderReportType";
import { LoadPagePanel } from "../../../../components";

export default function PrintButton(props: {
	buttonCaption: string,
	reportType: MaterialOrderReportType,
	visible?: boolean,
	elementAttr?: any
}) {

	const { order } = useContext(MaterialOrderContext);

	let [loading, setLoading] = useState(false);

	return (
		<>
			<Button
				text={props.buttonCaption}
				icon="Inscyth-Print"
				elementAttr={props.elementAttr}
				visible={props.visible ?? true}
				onClick={() => {
					setLoading(true);

					apiGenerateMaterialOrderReport(order.details.materialOrderID!, props.reportType)
						.then((result) => {
							if (result.isSuccess) {
								const file = new Blob(
									[Buffer.from(result.data, "base64")],
									{ type: 'application/pdf' });

								const fileURL = URL.createObjectURL(file);
								window.open(fileURL);
							}
							else {
								showErrorMessage(result.errorMessage!);
							}
						})
						.catch((reason) => {
							showErrorMessage(reason);
						})
						.finally(() => { setLoading(false); });
				}}>
			</Button>
			<LoadPagePanel visible={loading} />
		</>
	)
}
